import React from 'react';
import classNames from 'classnames';
import { formatNumber } from '../../utils/numberUtils';

const renderProgressValue = (current?: number, progress?: number, unit?: string, isBigDiff?: boolean) => {
  if (current === undefined) return '-';
  if (isBigDiff && current === 0) return '-';
  const unitToShow = unit ?? '';
  return (
    <span className={classNames('progress-value', { 'big-diff': isBigDiff, 'negative-big-diff': isBigDiff && current < 0 })}>
      {isBigDiff && current > 0 ? '+' : ''}
      {current} {unitToShow}
      {isBigDiff && progress !== undefined && progress !== 0 && <span className='progress-diff-separator'>/</span>}
      {progress !== undefined && progress !== 0 && (
        <span className={classNames('progress-diff', { 'negative-diff': progress < 0 })}>
          {progress > 0 ? '+' : ''}
          {formatNumber(progress, 1)} {isBigDiff ? '%' : unitToShow}
        </span>
      )}
    </span>
  );
};

interface Props {
  title: string;
  value: number | undefined;
  diff?: number;
  unit?: string;
  isBigDiff?: boolean;
  isRir?: boolean;
  isRpe?: boolean;
}

export const ExerciseProgressMetric = ({ title, value, diff, unit, isBigDiff, isRir, isRpe }: Props) => {
  return (
    <div className={classNames('metric', { 'metric-big-diff': isBigDiff, 'metric-rir': isRir, 'metric-rpe': isRpe })}>
      <span className='metric-label'>{title}</span>
      {renderProgressValue(value, diff, unit, isBigDiff)}
    </div>
  );
};
